export default {
  path: 'aggregator/road-information/:id?',
  name: 'Aggregator_road_information_details',
  meta: {
    parent_vue_name: 'Aggregator_road_information',
    breadcrumb_value: 'road-maintenance.road_information',
    open_tab: 'road-information',
    show: true
  },
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/RoadDetails.vue')
}
